import styled, { css } from 'vue-styled-components';

import theme from '@/config/theme';

export const NotificationType = ['default', 'info', 'question'] as const;

const notificationProps = {
  type: String,
  viewed: Boolean,
};

export type NotificationProps = {
  type: typeof NotificationType[number];
  viewed: boolean;
};

const modifiers = {
  default: {
    bgColor: theme.colors.secondaryAlpha20,
    color: theme.colors.supportSuccess,
  },
  info: {
    bgColor: theme.colors.infoLight,
    color: theme.colors.info,
  },
  question: {
    bgColor: theme.colors.secondaryAlpha20,
    color: theme.colors.supportSuccess,
  },
};

export const NotificationButtons = styled.div`
  display: flex;
  gap: ${theme.spacings.small};
  margin-top: 22px;
`;

export const NotificationIcon = styled('div', notificationProps)`
  ${({ viewed, type }: NotificationProps) => css`
    align-items: center;
    border-radius: ${theme.border.radius.circle};
    color: ${modifiers[type].color};
    display: flex;
    height: 54px;
    justify-content: center;
    min-width: 54px;
    width: 54px;

    background-color: ${viewed ? theme.colors.gray2 : modifiers[type].bgColor};

    ${type !== 'question' && `
      > svg {
        transform: scale(0.6);
      }`}
  `}
`;

export const NotificationText = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  width: 100%;

  > div {
    padding-left: ${theme.spacings.medium};
    word-break: break-word;
    max-width: calc(100% - 28px);

    > time {
      color: ${theme.colors.gray4};
      display: block;
      font-size: ${theme.font.sizes.p2};
      line-height: ${theme.font.lineHeights.p2};
      margin-bottom: 4px;
    }

    > p {
      color: ${theme.colors.gray6};
      font-size: ${theme.font.sizes.p2};
      line-height: ${theme.font.lineHeights.p2};
      text-align: justify
    }
  }

  > svg {
    color: ${theme.colors.gray4};
  }
`;

export const Wrapper = styled('div', notificationProps)`
  ${({ viewed, type }: NotificationProps) => css`
    background-color: ${theme.colors.white};
    border: 4px solid transparent;
    border-radius: ${theme.border.radius.xsmall};
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    padding: 28px;
    transition: .25s;
    width: 100%;
    
    ${type !== 'question' && `  
      align-items: center;
    `}

    &:hover {
      border: 4px solid ${theme.colors.secondaryAlpha20};
      border-radius: ${theme.border.radius.small};
      box-shadow: ${theme.shadow.lv1};

      div:last-of-type > svg {
        ${viewed && `color: ${theme.colors.secondary}`};
      }
    }

    ${!viewed && `box-shadow: ${theme.shadow.lv1}`};
  `}
`;
